import {
  GET_DISTRIBUTION_SUMMARY_BY_ID,
  LISTOFSTEPCALCULATION,
} from "@/services/constant/apiPath";
import { ccwpApi } from "@/services";

export const DisributionByCaseIdApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getDistributionByCaseID: builder.query<any, any>({
      query: (arg) => ({
        url: "Distribution/GetDistributionList",
        method: "GET",
        params: { ...arg },
      }),
    }),
    getDistributionSummaryById: builder.query<any, any>({
      query: (arg) => GET_DISTRIBUTION_SUMMARY_BY_ID + arg.id,
    }),
    listCalculationSteps: builder.query<any, any>({
      query: (arg) => ({
        url: "CalculationStep/ListCalculationSteps",
        method: "GET",
        params: { ...arg },
      }),
    }),
    createDistribution: builder.mutation({
      query: (data) => ({
        url: `Distribution/CreateDistribution`,
        method: "POST",
        body: data,
      }),
    }),
    createDuplicateDistribution: builder.mutation({
      query: (data) => ({
        url: `Distribution/ReplicateDistribution`,
        method: "POST",
        body: data,
      }),
    }),
    updateDistribution: builder.mutation({
      query: (data) => ({
        url: `Distribution/UpdateDistribution`,
        method: "PUT",
        body: data,
      }),
    }),

    deleteDistribution: builder.query({
      query: (id) => ({
        url: `Distribution/DeleteDistribution?DistributionId=${id}`,
        method: "DELETE",
      }),
    }),
    reCalculateEntitlement: builder.query({
      query: (distributionId) => ({
        url: `Distribution/StartReCalculateEntitlement?distributionId=${distributionId}`,
        method: "GET",
      }),
    }),
    calculateSettlement: builder.query({
      query: (distributionId) => ({
        url: `Distribution/StartCalculateSettlement?distributionId=${distributionId}`,
        method: "PUT",
      }),
    }),
    readDistributionProcessing: builder.query({
      query: (distributionId) => ({
        url: `Distribution/ReadProcessingStatus?distributionId=${distributionId}`,
        method: "GET",
      }),
    }),
    getDistributionWithSameSequenceId: builder.query({
      query: (distributionId) => ({
        url: `Distribution/GetDistributionListWithSameSequenceId?distributionId=${distributionId}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return { results: response || [] };
      },
    }),
  }),
});

export const {
  useGetDistributionByCaseIDQuery,
  useGetDistributionSummaryByIdQuery,
  useListCalculationStepsQuery,
  useCreateDistributionMutation,
  useCreateDuplicateDistributionMutation,
  useUpdateDistributionMutation,
  useLazyDeleteDistributionQuery,
  useLazyReCalculateEntitlementQuery,
  useLazyCalculateSettlementQuery,
  useReadDistributionProcessingQuery,
  useLazyReadDistributionProcessingQuery,
  useGetDistributionWithSameSequenceIdQuery,
} = DisributionByCaseIdApi;

export const configGetStepCalculationDataByIDApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getStepCalculationDataByIdApiData: builder.query<any, any>({
      query: ({ stepId, ...args }) => {
        return {
          url: LISTOFSTEPCALCULATION + stepId,
          method: "GET",
          params: { ...args },
        };
      },
    }),
  }),
});
export const { useGetStepCalculationDataByIdApiDataQuery } =
  configGetStepCalculationDataByIDApi;
